import { appConfigPerGame } from '../configs/appConfigPerGame';
import bgConfig from '../configs/backgammonConfig';
import spadesCongig from '../configs/spadesConfig';

const currentGame = process.env.REACT_APP_PRODUCT_NAME;

if (!process.env.REACT_APP_PRODUCT_NAME) {
  console.error('REACT_APP_PRODUCT_NAME do not set');
}

// the function returns an object with the current game config
const handleCurrentGameConfig = () => {
  console.log(currentGame);

  const configList = [bgConfig, spadesCongig];

  const currentGameConfig = configList.filter(item => {
    return item.info.gameName === currentGame;
  });

  return currentGameConfig[0];
};

// the function returns an object with the current page content
const handleCurrentContentConfig = (config, configsList) => {
  const currentContentConfig = configsList.filter(item => {
    return item.game === config.info.gameName;
  });

  return currentContentConfig[0];
};

export const currentGameConfig = handleCurrentGameConfig();
export const currentContentConfig = handleCurrentContentConfig(currentGameConfig, appConfigPerGame);
